import RouteEnum from "constants/RouteEnum";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Dispatch } from "redux";
import * as LogoutAction from "stores/auth/logout/LogoutAction";
import * as ProfileAction from "stores/profiles/ProfilesAction";
import { profileNotificationActive } from "utilities/UserProfileRoleUtility";
import Notification from "views/components/headers/notification/Notification";
import InviteMember from "views/components/invite-member/InviteMember";
import SwitchProfileItem from "../switch-profile-item/SwitchProfileItem";
import "./ProfileCircle.css";
import ProfileMedia from "./components/ProfileMedia";
import { dispatchAction } from "utilities/DispatchUtility";

const ProfileCircle: React.FC = () => {
  const { t } = useTranslation();

  const [menu, setMenuStatus] = useState(false);
  const dispatch: Dispatch = useDispatch();

  const mouseEnter = (e: any): void => {
    if (window.innerWidth < 992) {
      return;
    }
    e.preventDefault();
    setMenuStatus(true);
  };

  const mouseLeave = (e: any): void => {
    e.preventDefault();
    setMenuStatus(false);
  };

  const mouseClick = (e: any): void => {
    if (window.innerWidth < 992) {
      e.preventDefault();
      setMenuStatus(!menu);
    }
  };

  const logout = (e: React.MouseEvent<HTMLElement>): void => {
    e.preventDefault();
    dispatch(LogoutAction.requestLogout());
    dispatchAction(dispatch, ProfileAction.emptyProfile());
  };

  return (
    <div className="inline-item">
      <div
        className="dropdown dropdown-admin"
        onClick={mouseClick}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
        style={{ pointerEvents: "auto" }}
      >
        <Button className="dropdown-toggle profile-btn" type="button" data-toggle="dropdown" aria-expanded="false">
          <ProfileMedia />
        </Button>
        <div className={"dropdown-menu dropdown-menu-right profile-sub-menu " + (menu ? "show" : "")}>
          <ul className="admin-options">
            <li>
              <SwitchProfileItem />
            </li>
            <li>
              <Link to={RouteEnum.ProfileSettings} onClick={() => setMenuStatus(!menu)}>
                {t("header.header-control.profile-settings")}
              </Link>
            </li>
            <li>
              <Link to={RouteEnum.ProfileCreate} onClick={() => setMenuStatus(!menu)}>
                {t("header.header-control.my-profiles")}
              </Link>
            </li>
            <li>
              <InviteMember mouseLeave={mouseLeave} />
            </li>

            {profileNotificationActive() && <Notification mouseLeave={mouseLeave} />}

            <li>
              <Link to="#" onClick={logout}>
                {t("header.header-control.logout")}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProfileCircle;
